import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-stock-transfer-range',
    templateUrl: './stock-transfer-range.component.html',
  standalone: false
})
export class StockTransferRangeComponent{
    @Input() from: any = null;
    @Input() to: any = null;
  
    @Output() readonly fromChange = new EventEmitter();
    @Output() readonly toChange = new EventEmitter();
    constructor() { }


}